module.exports = __webpack_public_path__ + "img/41_BF19_empty_nest.a4b1c982.jpg";